import type { ISOString } from './other';

export enum PromotionPackageId {
  Cashback = 1,
  Deposit = 2,
}

export enum PromotionType {
  Cashback = 'COMMISSION',
  Bonus = 'WELCOME',
}

export type Promotion = {
  name: string;
  type: PromotionType;
  deposit_amount: number;
  deposit_amount_txt: string;
  promotion_amount: number;
  promotion_amount_txt: string;
  multiplier: string;
  rolling: number;
  rolling_txt: string;
  package_id: PromotionPackageId;
  turnover: number;
  turnover_txt: string;
  created_time: ISOString;
  description: string;
  rolling_time: ISOString;
  rolling_info: RollingTime[];
  end_time: ISOString;
};

export type RollingTime = {
  date: ISOString;
  event_id: string;
  invoice_id: number;
  rolling: number;
  amount: number;
  rolling_txt: string;
  amount_txt: string;
};

export type PromotionCommission = {
  date: string;
  stake: number;
  commission_estimate: number;
  rolling: string;
};
